package one.healthium.update_food_preferences.domain

import kotlinx.coroutines.flow.Flow
import one.healthium.channels.MealPlanChannel
import one.healthium.update_food_preferences.domain.models.FoodPreferenceCategoryOptions
import one.healthium.update_food_preferences.domain.models.FoodPreferencesCategoryModel

class FoodPreferenceInteractor(
    private val repository: FoodPreferencesRepository,
    private val melPlanChannel: MealPlanChannel,
) {
    fun getUserFoodPreferences(): Flow<List<FoodPreferencesCategoryModel>> {
        return repository.getUserFoodPreferences()
    }

    suspend fun updateUserFoodPreferences(options: List<FoodPreferenceCategoryOptions>) {
        repository.updateUserFoodPreferences(options)
        melPlanChannel.refreshMealPlan()
    }
}
